import React, { useMemo } from 'react';
import { Tooltip } from 'react-tooltip';
import icons from '../../helpers/icons';
import '../facebook/Style.css';
import RenderInBody from './RenderInBody';
import { v4 as uuidv4 } from 'uuid';

interface User {
  by: string;
  conversationid?: number;
  ConversationID?: number;
  ChatDialogID?: number;
  ImageName?: string;
}

interface FacebookCounterReactionProps {
  reaction: string;
  bg?: string;
  index: number;
  users: User[];
  place?: 'top' | 'right' | 'bottom' | 'left';
  recalculatePosition?: (e: React.MouseEvent<HTMLDivElement>) => void;
  idCounter: string;
}

export const FacebookCounterReaction: React.FC<FacebookCounterReactionProps> = ({
  reaction,
  bg: _bg,
  index,
  users,
  place = 'left',
  recalculatePosition,
  idCounter,
}) =>
{
  const uniqueId = useMemo(() => uuidv4(), []);

  const styles = {
    reaction: {
      width: '14px',
      height: '14px',
      backgroundSize: '100% 100%',
      backgroundImage: `url(${icons.find('facebook', reaction)})`,
      position: 'relative' as const,
      zIndex: index,
      marginTop: 1,
    },
  };

  const tooltip = useMemo(() =>
  {
    const reactionTitle = reaction.charAt(0).toUpperCase() + reaction.slice(1);

    const usersList = users
      .map(user =>
      {
        const hasConversation = (user.conversationid ?? 0) > 0 || (user.ConversationID ?? 0) > 0;
        const hasChatDialog = (user.ChatDialogID ?? 0) > 0;
        const defaultImage = hasConversation ? '../../Images/user.png' : 'img/user.png';
        const imageUrl = user.ImageName || defaultImage;

        let imageHtml = '';
        if (hasConversation || hasChatDialog)
        {
          imageHtml = `<div class='cch-image-profile-reaction' style='background-image: url("${imageUrl}");'></div>`;
        }

        return `
          <li>
            <div class='cch-user-item-cell-reaction'>
              ${imageHtml}
              <div class='cch-user-item-tooltip-reaction'>${user.by}</div>
            </div>
          </li>
        `;
      })
      .join('');

    return `
      <div class='containerTooltip'>
        <ul class='listReactions'>
          <li class='titleReaction'>${reactionTitle}</li>
          <li>
            <ul class='listUsers'>
              ${usersList}
            </ul>
          </li>
        </ul>
      </div>
    `;
  }, [reaction, users]);

  return (
    <div className="tooltipWrapper" style={{ marginRight: '2px' }}>
      <div
        data-tooltip-id={idCounter + uniqueId}
        data-tooltip-place={place}
        data-tooltip-html={tooltip}
        style={styles.reaction}
        className="tooltip-reactions"
        onMouseOver={recalculatePosition || undefined}
      />
      <RenderInBody>
        {/* Portals bubble through the React tree; stop clicks reaching the counter */}
        <div onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}>
          <Tooltip
            id={idCounter + uniqueId}
            className="extraClass"
            variant="light"
            positionStrategy="fixed"
            clickable
            offset={-10}
            delayHide={1000}
            delayShow={800}
            globalCloseEvents={{ clickOutsideAnchor: true }}
          />
        </div>
      </RenderInBody>
    </div>
  );
};

export default FacebookCounterReaction;
